export class breadcrumbsController {
    constructor(private $rootScope, private $timeout, private $state) {
        "ngInject"

    }

    routeChange() {
        if (this.$state.current.name == "listByCat")
            this.$timeout(() => {
                this.$rootScope.$emit('$routeChangeSuccess')
            }, 10)
    }

    $onInit() {

    }
}


// WEBPACK FOOTER //
// ./src/components/breadcrumbs/breadcrumbs.controller.ts